import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { TableError } from '../../types/common';
import {
  PlanService,
  Wealthlane_AwardService_Dtos_Response_ResponseDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const usePutPlanGrantDocumentDetail = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose: () => void,
  onError: (message: string, errors: TableError[]) => void
): UseMutationResult<
  Array<Wealthlane_AwardService_Dtos_Response_ResponseDto>,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload) => {
      return await handleRequest(PlanService.putApiAwardApiAppPlanPlanGrantDocumentDetail(payload));
    },
    {
      onSuccess: async (response: any) => {
        if (response !== null) {
          toast.success(<ToastComponent label='Success' message={`Plan Grant Document Edited.`} />);
          await queryClient.invalidateQueries('getPlanGrantDocumentDetailById');
        } else {
          throw {
            message: response?.message,
            errors: response?.errors,
            error: new Error(),
          };
        }
        onClose && onClose();
      },
      onError: (err: any) => {
        console.log('error', err);
        onError && onError(err?.message, err?.errors);
        onClose && onClose();
      },
    }
  );
};

export default usePutPlanGrantDocumentDetail;
